import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ClientManagementCard from "./ClientManagementCard";
import SpecialAccessManagementCard from "./SpecialAccessManagementCard";
import {
  getSpecialClientUsersManagementList,
  getClientUserList,
} from "../Actions/ClientManagementAPI";
import { getResetPassword } from "../Actions/ManagementAPI";

class SpecialAccessManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        Name: "",
        Company: "",
        PageNumber: 1,
        PageSize: 25,
      },
    };
    this.SearchData = this.SearchData.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }
  componentDidMount() {
    this.props.dispatch({
      type: "SubBannerTitle",
      data: "Special Access Management",
    });
    this.props.dispatch(
      getSpecialClientUsersManagementList(this.state.searchData)
    );
  }

  resetPasswordclick(item) {
    this.props.dispatch(getResetPassword(item));
  }

  SearchData(Pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = Pgno;
    dispatch(getSpecialClientUsersManagementList(this.state.searchData));
  }

  ClearInput() {
    this.state.searchData.Name = "";
    this.state.searchData.Company = "";
    this.props.dispatch(
      getSpecialClientUsersManagementList(this.state.searchData)
    );
    this.setState({});
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    dispatch({ type: "ShowSidePan", data: true });
    dispatch({ type: "ClientDetails", data: item });
    history.push(`/Home/Management/SpecialAccess/${item.clientId}`);
    // dispatch(getClientUserList(item.clientId));
    window.scrollTo(0, 0);
  }

  NewitemNav = () => {
    this.props.history.push("/Home/Management/SpecialAccessAdd");
    // this.props.dispatch({ type: "GetFleetManagerlist", data: null });
    // this.props.dispatch({ type: "GetTechSuperintendentlist", data: null });
    // this.props.dispatch({ type: "GetTechExecutivelist", data: null });
  };

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    if (e.target.value === "") {
      this.props.dispatch(
        getSpecialClientUsersManagementList(this.state.searchData)
      );
    }
    this.setState({});
  }

  hideSidePanel = () => {
    this.props.history.goBack();
    this.props.dispatch({ type: "ShowSidePan", data: false });
  };

  render() {
    const { ClientList, showSidePane } = this.props;
    return (
      <div className="full-height">
        <button
          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
          onClick={() => this.hideSidePanel()}
        >
          &larr; Back
        </button>
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1E3A8A",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title m-2 "
                          style={{ color: "092a51" }}
                        >
                          Special Access Management
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="card-title m-auto">Add</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row pb-3">
                        <div className="col-lg-4">
                          <label className="form-label">Name</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Name"
                            placeholder="Name"
                            value={this.state.searchData.Name}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className="col-lg-4">
                          <label className="form-label">Company</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            name="Company"
                            placeholder="Company"
                            value={this.state.searchData.Company}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={"col-lg-4 pt-3"}>
                          <br></br>
                          <div
                            className="search-btn-col"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchData(1)}
                            >
                              {" "}
                              Search{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              Clear{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {ClientList ? (
                <SpecialAccessManagementCard
                  arraylist={ClientList?.data ?? []}
                  pageSize={ClientList?.pagination?.pageSize ?? 0}
                  currentPage={ClientList?.pagination?.currentPage ?? 1}
                  totalRecords={
                    ClientList?.pagination?.totalcount
                      ? ClientList.pagination.totalcount
                      : 0
                  }
                  setUpdatedState={(value) => this.SearchData(value)}
                  resetPasswordclick={(item) =>
                    this.resetPasswordclick(item.email)
                  }
                  //   eyeclick={(item) => this.eyeclick(item)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditClient");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ClientList: state.SpecialAccessReducer.specialClientUsersList || [],
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SpecialAccessManagement)
);
